import { MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BUYERS = [
  "Spice Wholesalers & Traders",
  "Kirana & Grocery Retailers",
  "Dry-Fruit & Gourmet Stores",
  "Sweet Shops & Halwais",
  "Commercial Bakeries",
  "Caterers & Function Contractors",
  "Tea & Chai Masala Brands",
  "Food Manufacturers & Processors",
  "Institutional Kitchens & Hotels",
  "District Spice Distributors",
];

export const BuyersServe = () => {
  return (
    <section id="buyers" className="py-20 px-4 sm:px-6 max-w-7xl mx-auto space-y-16" data-testid="buyers-section">
      <div className="grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-7 space-y-6">
          <div className="space-y-2">
            <span className="text-xs font-bold uppercase tracking-widest text-spice-green">Client Profiles</span>
            <h2 className="text-2xl sm:text-3xl font-bold text-spice-ink">Buyers We Serve</h2>
            <p className="text-sm text-spice-muted">
              We supply regular and lot-based volumes to trade and commercial clients across key food sectors.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-3 text-xs">
            {BUYERS.map((buyer, i) => (
              <div
                key={buyer}
                data-testid={`buyer-type-${i + 1}`}
                className="p-3 bg-white rounded border border-spice-line font-medium flex items-center gap-2"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-spice-green shrink-0"></span> {buyer}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="lg:col-span-5 space-y-6" delay={120}>
          <div className="space-y-2" id="service-area">
            <span className="text-xs font-bold uppercase tracking-widest text-spice-green">Logistics &amp; Coverage</span>
            <h2 className="text-2xl sm:text-3xl font-bold text-spice-ink">Service Area</h2>
          </div>

          <div className="p-5 bg-white rounded-lg border border-spice-line space-y-4" data-testid="service-area-card">
            <div className="p-4 bg-spice-sand rounded border-l-4 border-spice-green space-y-1">
              <span className="text-xs font-bold text-spice-green uppercase tracking-wide">Primary Market</span>
              <p className="text-sm font-semibold text-spice-ink" data-testid="service-area-primary">
                Hyderabad &amp; Telangana
              </p>
            </div>
            <p className="text-xs text-spice-muted leading-relaxed" data-testid="service-area-secondary">
              Orders for other Indian locations are considered according to quantity, logistics, payment confirmation and commercial feasibility.
            </p>

            <div className="aspect-[16/9] rounded bg-spice-sand border border-spice-line flex flex-col items-center justify-center gap-2 text-xs p-3">
              <MapPin className="w-6 h-6 text-spice-green" />
              <span className="font-bold text-spice-green">Distribution Hub: Saidabad, Hyderabad</span>
              <span className="text-[11px] text-spice-subtle">Pincode: 500059 • Telangana</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
